
import { supabase } from '../../supabase';
import { toast } from 'sonner';
import { adminError } from '@/lib/utils/admin-logger';

export async function verifyAuthAndAuthor(authorId: string): Promise<boolean> {
  // Check if the user is authenticated
  const { data: sessionData } = await supabase.auth.getSession();
  if (!sessionData.session) {
    toast.error('Authentication required', { 
      description: 'Please sign in to upload a paper' 
    });
    return false;
  }

  // Verify the author ID matches the current user
  if (sessionData.session.user.id !== authorId) {
    toast.error('Authentication error', { 
      description: 'You can only upload papers as yourself' 
    });
    return false;
  }

  return true;
}

export async function getAuthorData(authorId: string) {
  const { data: authorData, error: authorError } = await supabase
    .from('users')
    .select('*')
    .eq('id', authorId)
    .single();
    
  if (authorError) {
    adminError('Error fetching author information:', authorError);
    toast.error('Failed to get author information', {
      description: authorError.message
    });
    return null;
  }

  return authorData;
}

